import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";

var _templateObject;

import React from 'react'; // eslint-disable-next-line no-restricted-imports

import { Popover as AntPopover } from 'antd';
import styled from 'styled-components'; // eslint-disable-next-line react/destructuring-assignment

var FilteredPopover = function FilteredPopover(props) {
  return /*#__PURE__*/React.createElement(AntPopover, _extends({
    overlayClassName: props.className
  }, props));
};

var Popover = styled(FilteredPopover)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-popover-inner-content {\n    padding: 0;\n  }\n"])));
export default Popover;